<template>
    <v-row id="route-segments">
        <v-col cols="12" sm="3" class="mb-4" v-for="route in routes" :key="route.routeId">
            <v-card
            >
                <v-row class="pt-5 pb-5 pr-10 pl-10">
                    <v-col cols="6" class="p-0">
                        <p class="routes" @click="editRoute(route.routeId)">
                            {{route.name}}
                        </p>
                    </v-col>
                    <v-col cols="6" class="p-0">
                        <p class="routes-status text-right align-center" v-if="route.statusId == 2">
                            <img src="/images/_SVGs/environmental/transportador.svg" alt="road" onload="SVGInject(this)" class="mr-1" width="23" height="23"/> {{route.statusName}}
                        </p>
                        <p class="routes-status text-right align-center" :style="route.statusId == 1 ? 'opacity: 0.3;': ''" v-else>
                            <img src="/images/_SVGs/environmental/pendente.svg" alt="pendente" onload="SVGInject(this)" class="mr-1" width="23" height="23"/> {{route.statusName}}
                        </p>
                    </v-col>

                    <v-col cols="6" class="p-0">
                        <p class="routes-date">
                           {{ route.transportationStartDate? route.transportationStartDate : '-'  | formatOnlyDate}}
                        </p>
                    </v-col>
                    <v-col cols="6" class="p-0">
                        <p class="routes-km text-right">
                            <!--{{route.kms}} Km -->
                        </p>
                    </v-col>

                    <v-col cols="3" class="p-0 mt-3 d-flex align-center">
                        <span v-if="route.statusId == 2">
                            <img src="/images/_SVGs/environmental/oficinas.svg" alt="oficinas" onload="SVGInject(this)" width="20" height="20"/> {{route.doneEgars}}/{{route.totalEgars}}
                        </span>
                        <span v-else>
                            <img src="/images/_SVGs/environmental/oficinas.svg" alt="oficinas" onload="SVGInject(this)" width="20" height="20"/> {{route.totalEgars}}x
                        </span>
                    </v-col>
                    <v-col cols="9" class="p-0 mt-3 d-flex align-center" style="justify-content: flex-end; height: 28px;">
                        <v-progress-linear :value="calcPercentual(route.totalEgars,route.doneEgars)" v-if="route.statusId == 2"></v-progress-linear>
                        <v-btn elevation="0" rounded small class="btn-primary" style="justify-content: flex-end;" v-else @click="lancarRota(route.routeId)">{{$t('environmental-management.scheduling.route-segments-btn')}}</v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props:{
            routes: Array | Object
        },
        data(){
            return{

            }
        },
        methods:{
            calcPercentual(total, done){
                if(done > 0){
                    let calc = (done * 100);
                    return calc / total;
                }
                return 0
            },
            editRoute(id){
                this.$router.push({ name: 'environmentalManagementRouteManagementEdit', params: { id: id }})
            },
            lancarRota(id){
                this.$emit('showModal', id);
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

::v-deep .v-card{
    box-shadow: 0px 2px 6px #0000000F !important;
}
#route-segments{
    p{
        font-size: 14px;
        margin-bottom: 0;
        &.routes {
            color: var(--v-primary-base);
            font-weight: 500;
            cursor: pointer;
        }
        &.routes-date{
            font-size: 14px;
            color: black;
            font-weight: bold;
        }
    }
    .routes-status{
        font-size:13px;
    }
    .btn-primary{
        background-color: var(--v-primary-base);
        color: #fff;
        ::v-deep .v-btn__content{
            font-size: 10px;
        }

    }
}
</style>
